import {
  CHECK,
  CHECK_FAILURE,
  CHECK_SUCCESS,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  REGISTER_SAGA,
  GOOGLE_INITIALIZED,
  SENT_RESET_PASSWORD,
  SENT_RESET_PASSWORD_PENDING,
  SENT_RESET_PASSWORD_SUCCESS,
  SENT_RESET_PASSWORD_FAILURE,
  // ONE TIME VERIFICATION
  ACCOUNT_ACTIVATE,
  ACCOUNT_ACTIVATE_SUCCESS,
  ACCOUNT_ACTIVATE_FAILURE,
  // UPDATE PASSWORD
  UPDATE_PASSWORD,
  UDPATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  RESET_UPDATE_PASSWORD,
  // SUSPEND/ACTIVATE USER
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
  REGISTER_ACCOUNT,
  REGISTER_ACCOUNT_SUCCESS,
  REGISTER_ACCOUNT_FAILURE,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  VERIFY_2FA,
  VERIFY_2FA_SUCCESS,
  VERIFY_2FA_FAILURE,
  RESEND_2FA,
  RESEND_2FA_SUCCESS,
  RESEND_2FA_FAILURE,
  SHOW_2FA_SCREEN,
  HIDE_2FA_SCREEN,
} from "./constants";
const actions = {
  registerSaga: () => {
    return {
      type: REGISTER_SAGA,
    };
  },
  login: (credentials, history) => {
    return {
      type: LOGIN,
      credentials,
      history,
    };
  },
  loginSuccess: (payload) => {
    return {
      type: LOGIN_SUCCESS,
      payload,
    };
  },
  loginFailure: (error) => {
    return {
      type: LOGIN_FAILURE,
      error,
    };
  },
  check: (token, history) => {
    return {
      type: CHECK,
      token,
      history,
    };
  },

  checkSuccess: (payload) => {
    return {
      type: CHECK_SUCCESS,
      payload,
    };
  },
  checkFailure: (error) => {
    return {
      type: CHECK_FAILURE,
      error,
    };
  },
  logout: (history) => {
    return {
      type: LOGOUT,
      history,
    };
  },
  logoutSuccess: (payload) => {
    return {
      type: LOGOUT_SUCCESS,
      payload,
    };
  },
  logoutFailure: (error) => {
    return {
      type: LOGOUT_FAILURE,
      error,
    };
  },
  setGoogleReference: (payload) => {
    return {
      type: GOOGLE_INITIALIZED,
      payload,
    };
  },
  sentResetLink: (payload) => {
    return {
      type: SENT_RESET_PASSWORD,
      payload,
    };
  },
  sentResetLinkPending: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_PENDING,
      payload,
    };
  },
  sentResetLinkSuccess: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_SUCCESS,
      payload,
    };
  },
  sentResetLinkFailure: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_FAILURE,
      payload,
    };
  },
  // ONE TIME VERIFICATION
  activateAccount: (payload) => {
    return {
      type: ACCOUNT_ACTIVATE,
      payload,
    };
  },
  activateAccountSuccess: (payload) => {
    return {
      type: ACCOUNT_ACTIVATE_SUCCESS,
      payload,
    };
  },
  activateAccountFailure: (payload) => {
    return {
      type: ACCOUNT_ACTIVATE_FAILURE,
      payload,
    };
  },
  // ONE TIME VERIFICATION PASSWORD UPDATE
  updatePassword: (payload) => {
    return {
      type: UPDATE_PASSWORD,
      payload,
    };
  },
  updatePasswordSuccess: (payload) => {
    return {
      type: UDPATE_PASSWORD_SUCCESS,
    };
  },
  updatePasswordFailure: (payload) => {
    return {
      type: UPDATE_PASSWORD_FAILURE,
      payload,
    };
  },
  resetUpdatePassword: (payload) => {
    return {
      type: RESET_UPDATE_PASSWORD,
      payload,
    };
  },

  registerAccount: (payload) => {
    return {
      type: REGISTER_ACCOUNT,
      payload,
    };
  },
  registerAccountSuccess: (payload) => {
    return {
      type: REGISTER_ACCOUNT_SUCCESS,
      payload,
    };
  },
  registerAccountFailure: (payload) => {
    return {
      type: REGISTER_ACCOUNT_FAILURE,
      payload,
    };
  },
  // SUSPEND/ACTIVATE USER
  activateUser: (payload) => {
    return {
      type: ACTIVATE_USER,
      payload,
    };
  },
  activateUserSuccess: (payload) => {
    return {
      type: ACTIVATE_USER_SUCCESS,
      payload,
    };
  },
  activateUserFailure: (payload) => {
    return {
      type: ACTIVATE_USER_FAILURE,
      payload,
    };
  },
  verifyOTP: (payload) => {
    return {
      type: VERIFY_OTP,
      payload,
    };
  },
  verifyOTPSuccess: (payload) => {
    return {
      type: VERIFY_OTP_SUCCESS,
      payload,
    };
  },
  verifyOTPFailure: (payload) => {
    return {
      type: VERIFY_OTP_FAILURE,
      payload,
    };
  },

  downloadFile: (payload) => {
    return {
      type: DOWNLOAD_FILE,
      payload,
    };
  },
  downloadFileSuccess: (payload) => {
    return {
      type: DOWNLOAD_FILE_SUCCESS,
      payload,
    };
  },
  downloadFileFailure: (payload) => {
    return {
      type: DOWNLOAD_FILE_FAILURE,
      payload,
    };
  },
  forgotPassword: (credentials, history) => {
    return {
      type: FORGOT_PASSWORD,
      credentials,
      history,
    };
  },
  forgotPasswordSuccess: (payload) => {
    return {
      type: FORGOT_PASSWORD_SUCCESS,
      payload,
    };
  },
  forgotPasswordFailure: (error) => {
    return {
      type: FORGOT_PASSWORD_FAILURE,
      error,
    };
  },
  resetPassword: (credentials, history) => {
    return {
      type: RESET_PASSWORD,
      credentials,
      history,
    };
  },
  resetPasswordSuccess: (payload) => {
    return {
      type: RESET_PASSWORD_SUCCESS,
      payload,
    };
  },
  resetPasswordFailure: (error) => {
    return {
      type: RESET_PASSWORD_FAILURE,
      error,
    };
  },
  // Two Factor Authentication
  verify2FA: (payload) => {
    return {
      type: VERIFY_2FA,
      payload,
    };
  },
  verify2FASuccess: (payload) => {
    return {
      type: VERIFY_2FA_SUCCESS,
      payload,
    };
  },
  verify2FAFailure: (error) => {
    return {
      type: VERIFY_2FA_FAILURE,
      error,
    };
  },
  resend2FA: (payload) => {
    return {
      type: RESEND_2FA,
      payload,
    };
  },
  resend2FASuccess: (payload) => {
    return {
      type: RESEND_2FA_SUCCESS,
      payload,
    };
  },
  resend2FAFailure: (error) => {
    return {
      type: RESEND_2FA_FAILURE,
      error,
    };
  },
  show2FAScreen: (payload) => {
    return {
      type: SHOW_2FA_SCREEN,
      payload,
    };
  },
  hide2FAScreen: () => {
    return {
      type: HIDE_2FA_SCREEN,
    };
  },
};
export default actions;
